import { useState, useEffect, useContext } from "react";
import { MapViewContext } from "../contexts/MapViewContext";
import CityContext from "../contexts/CityContext";
import * as reactiveUtils from "@arcgis/core/core/reactiveUtils";
import { AlignmentContext } from "../contexts/AlignmentContext";

function useLayerList() {
	const mapView = useContext(MapViewContext);
	const { city } = useContext(CityContext);
	const [layerList, setLayerList] = useState<any[]>([]);
	const [overlays, setOverlays] = useState<any[]>([]);
	const { alignment } = useContext(AlignmentContext);

	const getLayers = () => {
		mapView?.when((view: __esri.MapView) => {
			setLayerList([]);
			setOverlays([]);

			view.map.layers.forEach((layer: any) => {
				layer.layers?.map((x: any) => {});
				if (city == null) {
					if (layer.type == "group") {
						layer.visible = true;
						layer.layers.map((x: any) => {
							if (x.title.includes("Enter your city")) {
								setLayerList((layerList) => [x, ...layerList]);
							}
						});
					}
				} else {
					if (layer.type == "group") {
						setOverlays((overlays) => [layer, ...overlays]);
					} else if (
						layer.title != "Park and Trail Sketch" &&
						layer.title != "service area gl" &&
						layer.title != "walk layer" &&
						layer.title != "ParkServe Place" &&
						layer.title != "ParkServe Urban Area" &&
						layer.title != "Searched Address"
					) {
						if (
							(alignment == "city" ||
								alignment == "park" ||
								alignment == "evaluate" ||
								alignment == "") &&
							layer?.title?.toLowerCase().includes("urban")
						) {
							return;
						} else if (
							alignment == "urban" &&
							layer?.title?.toLowerCase().includes("place")
						) {
							return;
						}
						setLayerList((layerList) => [layer, ...layerList]);
					}
				}
			});
		});
	};

	reactiveUtils.watch(
		() => [mapView?.map.allLayers.map((layer) => layer.visible)],
		() => {
			setLayerList([]);
			setOverlays([]);
			getLayers();
		}
	);

	useEffect(() => {
		if (alignment != "park" || alignment != "evaluate") {
			setLayerList([]);
			setOverlays([]);
			getLayers();
		}
	}, [mapView, alignment, city]);

	return { layerList, overlays };
}

export default useLayerList;
